export const silentFailURLs = ['/services/verify_token'];
